import { useState, useEffect } from "react";
import { useGetAllLevelsQuery } from "src/services/LevelService";

const useLevels = () => {
    const [levels, setLevels] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllLevelsQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setLevels(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { levels, isDataLoading };
};

export default useLevels;
